module.exports = __webpack_public_path__ + "img/404.8a302e06.png";